var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-live-list-form',{staticClass:"pt-live-list-form__page",attrs:{"isEdit":_vm.is_edit,"id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }